import { render } from "./BulkStatusUpdateModal.vue?vue&type=template&id=af8b0772&scoped=true&ts=true&lang=pug"
import script from "./BulkStatusUpdateModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BulkStatusUpdateModal.vue?vue&type=script&lang=ts&setup=true"

import "./BulkStatusUpdateModal.vue?vue&type=style&index=0&id=af8b0772&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8b0772"]])

export default __exports__